import { jsxs, jsx } from 'react/jsx-runtime';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';
import { assertError } from '@backstage/errors';

function DeleteEntityConfirmationDialog(props) {
  const { open, onClose, onConfirm } = props;
  const [busy, setBusy] = useState(false);
  const onDelete = async () => {
    setBusy(true);
    try {
      onConfirm();
    } catch (err) {
      assertError(err);
    } finally {
      setBusy(false);
    }
  };
  return /* @__PURE__ */ jsxs(Dialog, { open, onClose, children: [
    /* @__PURE__ */ jsx(DialogTitle, { id: "responsive-dialog-title", children: "Are you sure you want to delete this entity?" }),
    /* @__PURE__ */ jsxs(DialogActions, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "contained",
          color: "secondary",
          disabled: busy,
          onClick: onDelete,
          children: "Delete"
        }
      ),
      /* @__PURE__ */ jsx(Button, { onClick: onClose, color: "primary", children: "Cancel" })
    ] })
  ] });
}

export { DeleteEntityConfirmationDialog };
//# sourceMappingURL=DeleteEntityConfirmationDialog.esm.js.map
